<template>
  <div
    id="actions_bar"
    class="actions_bar"
  >
    <div class="left">
      <slot name="left"></slot>
    </div>
    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const alignBar = computed(() => {
  return props.align === 'right' ? 'flex-end' : props.align === 'left' ? 'flex-start' : props.align;
});

const props = defineProps({
  align: {
    type: String,
    validator(value) {
      return ['left', 'right', 'space-between', 'center'].includes(value);
    },
  },
});
</script>

<style>
.actions_bar {
  width: 100%;
  background-color: white;
  margin-right: 10px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
  justify-content: v-bind(alignBar);
  padding: 20px 20px;
}
.el-button:hover {
  border: 1px solid #aaa;
}

.right {
  display: flex;
}
</style>
